import { money, isReported, FigureNote, Notes, NotAvailable } from "./IntlBits";

const NAME = { UK: "England (Plan 5 and Student Finance England)", US: "United States (federal Direct Loans)" };

export function LoanPanel({ loans, sources }) {
  return (
    <div data-testid="sci-intl-loans" className="grid gap-6 lg:grid-cols-2">
      {["UK", "US"].map((c) => (
        <div key={c} className="rounded-xl border border-stone-200 bg-white p-5" data-testid={`sci-intl-loans-${c.toLowerCase()}`}>
          <h3 className="font-editorial text-xl text-stone-900">{NAME[c]}</h3>
          <dl className="mt-4 divide-y divide-stone-100">
            {loans[c].rules.map((r) => (
              <div key={r.id} className="flex items-start justify-between gap-4 py-2.5" data-testid={`sci-intl-loan-${r.id}`}>
                <dt className="text-sm text-stone-700">
                  {r.label}
                  {r.period && <span className="block text-[11px] text-stone-500">{r.period}</span>}
                </dt>
                <dd data-testid={`sci-intl-loan-${r.id}-value`} className="whitespace-nowrap font-editorial text-lg text-stone-900">
                  {isReported(r) ? money(r.value, r.unit) : <NotAvailable testId={`sci-intl-loan-${r.id}-na`} />}
                </dd>
              </div>
            ))}
          </dl>
          <ul className="mt-4 list-disc space-y-1 pl-5 text-xs text-stone-600" data-testid={`sci-intl-loans-${c.toLowerCase()}-caveats`}>
            {loans[c].caveats.map((t) => <li key={t}>{t}</li>)}
          </ul>
          <Notes testId={`sci-intl-loans-${c.toLowerCase()}-notes`}>
            <ul className="space-y-1.5">{loans[c].rules.map((r) => <FigureNote key={r.id} f={r} sources={sources} testId={`sci-intl-loan-${r.id}-source`} />)}</ul>
          </Notes>
        </div>
      ))}
    </div>
  );
}
